import React from "react";
import { observer } from "mobx-react";
import { AssociatedDocumentSignedEditionViewStore } from "../../store";
import { AssociatedDocumentSignedEditionViewForm } from "./AssociatedDocumentSignedEditionViewForm";
import { ErrorDialog } from "../../../../common/controls";
import { DownloadIcon } from "../../../../icons";
import { VisibilityIcon } from "../../../../icons";
import { isOriginalCrudStatus, RowCrudStatus } from "../../../common/types";
import { useRootStore } from "../../../../store/contexts";
import { PDFViewerDialog } from "../../../../common/components/PDFViewerDialog";

export type AssociatedDocumentSignedEditionViewProps = {
  associatedDocumentSignedEditionViewStore: AssociatedDocumentSignedEditionViewStore;
};

export const AssociatedDocumentSignedEditionView: React.FC<AssociatedDocumentSignedEditionViewProps> =
  observer(({ associatedDocumentSignedEditionViewStore }) => {
    const { langStore } = useRootStore();

    const getViewAction = (
      onDownload: (props: {
        id: string;
        type: string;
        name: string;
        __status__: RowCrudStatus;
      }) => void,
      onViewPdf?: (props: any) => void
    ) => {
      const actions: any[] = [];
      if (onViewPdf) {
        actions.push({
          columnName: "__action_view_pdf",
          onClick: (props: any) =>
            isOriginalCrudStatus(props.__status__) ? onViewPdf(props) : {},
          icon: <VisibilityIcon />,
          label: langStore.viewCommand,
          isActionEnabled: (props: any) =>
            props.name?.toLowerCase().endsWith(".pdf"),
        });
      }
      actions.push({
        columnName: "__action_view",
        onClick: (props: any) =>
          isOriginalCrudStatus(props.__status__) ? onDownload(props) : {},
        icon: <DownloadIcon />,
        label: langStore.downloadCommand,
      });
      return actions;
    };

    return (
      <div>
        <AssociatedDocumentSignedEditionViewForm
          name={associatedDocumentSignedEditionViewStore.nameValue}
          fileFiles={associatedDocumentSignedEditionViewStore.fileFiles}
          onPrint={(handlePrint: () => void) =>
            associatedDocumentSignedEditionViewStore.printAssociatedDocumentSignedEdition(
              handlePrint
            )
          }
          onCancel={() =>
            associatedDocumentSignedEditionViewStore.cancelAssociatedDocumentSignedEdition()
          }
          onEdit={
            associatedDocumentSignedEditionViewStore.isEditEnabled
              ? () =>
                  associatedDocumentSignedEditionViewStore.editAssociatedDocumentSignedEdition()
              : undefined
          }
          fileViewAction={getViewAction(
            (props) =>
              associatedDocumentSignedEditionViewStore.fileDownload(
                props,
                "file"
              ),
            (props) =>
              associatedDocumentSignedEditionViewStore.viewFilePdf(
                props,
                "file"
              )
          )}
        />
        <ErrorDialog
          open={associatedDocumentSignedEditionViewStore.errorDialogOpened}
          title={associatedDocumentSignedEditionViewStore.errorTitle}
          description={
            associatedDocumentSignedEditionViewStore.errorDescription
          }
          onClose={() =>
            associatedDocumentSignedEditionViewStore.closeErrorDialog()
          }
        />
        <PDFViewerDialog
          open={associatedDocumentSignedEditionViewStore.pdfViewerOpen}
          onClose={() =>
            associatedDocumentSignedEditionViewStore.closePdfViewer()
          }
          pdfUrl={associatedDocumentSignedEditionViewStore.pdfViewerUrl}
          title={associatedDocumentSignedEditionViewStore.pdfViewerTitle}
        />
      </div>
    );
  });
